type CountryData = {
  code: string;
  name: string;
  nameKey: string;
  flag: string;
};

export const COUNTRY_DATA: CountryData[] = [
  {
    code: 'ALB',
    name: 'Albania',
    nameKey: 'countries.alb',
    flag: '🇦🇱',
  },
  {
    code: 'AUT',
    name: 'Austria',
    nameKey: 'countries.aut',
    flag: '🇦🇹',
  },
  {
    code: 'AZE',
    name: 'Azerbaijan',
    nameKey: 'countries.aze',
    flag: '🇦🇿',
  },
  {
    code: 'CYP',
    name: 'Cyprus',
    nameKey: 'countries.cyp',
    flag: '🇨🇾',
  },
  {
    code: 'CZE',
    name: 'Czechia',
    nameKey: 'countries.cze',
    flag: '🇨🇿',
  },
  {
    code: 'DEU',
    name: 'Germany',
    nameKey: 'countries.deu',
    flag: '🇩🇪',
  },
  {
    code: 'DNK',
    name: 'Denmark',
    nameKey: 'countries.dnk',
    flag: '🇩🇰',
  },
  {
    code: 'EST',
    name: 'Estonia',
    nameKey: 'countries.est',
    flag: '🇪🇪',
  },
  {
    code: 'FIN',
    name: 'Finland',
    nameKey: 'countries.fin',
    flag: '🇫🇮',
  },
  {
    code: 'GEO',
    name: 'Georgia',
    nameKey: 'countries.geo',
    flag: '🇬🇪',
  },
  {
    code: 'GRC',
    name: 'Greece',
    nameKey: 'countries.grc',
    flag: '🇬🇷',
  },
  {
    code: 'HRV',
    name: 'Croatia',
    nameKey: 'countries.hrv',
    flag: '🇭🇷',
  },
  {
    code: 'HUN',
    name: 'Hungary',
    nameKey: 'countries.hun',
    flag: '🇭🇺',
  },
  {
    code: 'ISL',
    name: 'Iceland',
    nameKey: 'countries.isl',
    flag: '🇮🇸',
  },
  {
    code: 'ISR',
    name: 'Israel',
    nameKey: 'countries.isr',
    flag: '🇮🇱',
  },
  {
    code: 'JPN',
    name: 'Japan',
    nameKey: 'countries.jpn',
    flag: '🇯🇵',
  },
  {
    code: 'KAZ',
    name: 'Kazakhstan',
    nameKey: 'countries.kaz',
    flag: '🇰🇿',
  },
  {
    code: 'LTU',
    name: 'Lithuania',
    nameKey: 'countries.ltu',
    flag: '🇱🇹',
  },
  {
    code: 'LUX',
    name: 'Luxembourg',
    nameKey: 'countries.lux',
    flag: '🇱🇺',
  },
  {
    code: 'LVA',
    name: 'Latvia',
    nameKey: 'countries.lva',
    flag: '🇱🇻',
  },
  {
    code: 'MLT',
    name: 'Malta',
    nameKey: 'countries.mlt',
    flag: '🇲🇹',
  },
  {
    code: 'NOR',
    name: 'Norway',
    nameKey: 'countries.nor',
    flag: '🇳🇴',
  },
  {
    code: 'POL',
    name: 'Poland',
    nameKey: 'countries.pol',
    flag: '🇵🇱',
  },
  {
    code: 'SRB',
    name: 'Serbia',
    nameKey: 'countries.srb',
    flag: '🇷🇸',
  },
  {
    code: 'SVK',
    name: 'Slovakia',
    nameKey: 'countries.svk',
    flag: '🇸🇰',
  },
  {
    code: 'SVN',
    name: 'Slovenia',
    nameKey: 'countries.svn',
    flag: '🇸🇮',
  },
  {
    code: 'SWE',
    name: 'Sweden',
    nameKey: 'countries.swe',
    flag: '🇸🇪',
  },
  {
    code: 'UZB',
    name: 'Uzbekistan',
    nameKey: 'countries.uzb',
    flag: '🇺🇿',
  },
];
export const getCountry = (code: string): CountryData | undefined => COUNTRY_DATA.find(c => code === c.code);
